import Screen from '../../../../shared/utils/screen';
import FlavourConfig from '../../../../shared/config/flavours';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import { MenuItemProps as Props } from '../../../../shared/types/props/menu';

const LanguageSelector = styled.img<Props>`
  left: ${-32 * Screen.widthRatio}px;
  padding-top: ${7 * Screen.widthRatio}px;
  position: absolute;
  width: ${18 * Screen.widthRatio}px;
`;

LanguageSelector.defaultProps = {
  src: FlavourConfig.images.menuSelector,
};

export default withAnimation(withImage(LanguageSelector, false));
